import React, { useContext, useState } from "react";
import { DrawerContext } from "../../../../store/DrawerContext/DrawerContext";
import { Drawer, Segmented, Spin, Tabs, Tooltip } from "antd";
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import Reviews from "../reviews/reviews/Reviews";
import CardDetailsReview from "../../../pages/menuReviews/3_1_Reviews/Reviews/CardDetailsReview";
import { DoubleLeftOutlined, EnvironmentOutlined, StarFilled, } from "@ant-design/icons";
import { useAuth } from "../../../../store/AuthContext/AuthContext";
import SelectPeriod from "../selectMonths/SelectPeriod";
import { PageFilters, PageFilterField } from "../../../pages/common/PageFilters";
import { DrawerPanelTitle, drawerPanelStyles } from "../../../pages/common/Drawers/DrawerPanelTitle";
import { ResultsPagination } from "../../design/ResultsPagination/ResultsPagination";

export const ReviewsDrawer = () => {

    const { reviewsDrawer, setReviewsDrawer } = useContext(DrawerContext);
    const [selectedReview, setSelectedReview] = useState<any>(null);
    const [filterStatus, setFilterStatus] = useState('&status=NOT_REPLIED');
    const [filterScore, setFilterScore] = useState('');
    const [filterReference, setFilterReference] = useState(reviewsDrawer ? '&periodOpt=' + reviewsDrawer.range : '&periodOpt=LAST_30DAYS');
    const [requestParams, setRequestParams] = useState(filterStatus + filterScore + filterReference);    
    const [reviewsList, setReviewsList] = useState<any>(null);
    const [location, setLocation] = useState<any>(null);
    const [pagination, setPagination] = useState<any>({page:1});  
    const { projectGroup } = useAuth();

    const [categories, setCategories] = useState([]);    	  
  
    useFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/${projectGroup.group}/category`
        , {},[]  ,(data) => {          
        setCategories(data);					
        }
    );

    const onRangeChange = (range: any) => {
        setFilterReference('&periodOpt=' + range);
        setRequestParams(filterStatus + filterScore + '&periodOpt=' + range);      
      };

    const handleReviewClick = (review: React.SetStateAction<null>) => {
        setSelectedReview(review);
    };

    function nextReview(currentReview: any) {

        if (reviewsList && currentReview.nextReview) {                        
            const nextReview  = reviewsList.find((element: any) => element.name === currentReview.nextReview);                  
            setSelectedReview(nextReview);                  
        } else {
            setUpdateData(!updateData)
            setSelectedReview(null);
        }        
    }

    const [updateData, setUpdateData] = useState(false)

    const { isLoading }: any = useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + `/${reviewsDrawer.id}/reviewsDrawer?${requestParams}`
    , {}, [updateData],
    (data) => {      
        setReviewsList(data.reviews);
        setLocation(data.locationHeader);
        setPagination(data.pagination);        
    });

    return (
        <>
            {reviewsDrawer && (
                <Drawer
                    placement="right"
                    width={'60%'}
                    open={reviewsDrawer != null}
                    onClose={() => setReviewsDrawer(null)}
                    {...drawerPanelStyles}
                    title={
                        <DrawerPanelTitle
                            title="Reseñas"
                            location={location}
                        />
                    }>

                    <div style={{ marginRight: '10px', display: 'flex', justifyContent: 'flex-end', height: '20px', color:'royalblue' }}>
                        {selectedReview ?
                            <p style={{ cursor: 'pointer' }} onClick={() => { setUpdateData(!updateData); setSelectedReview(null) }}>
                                <b><DoubleLeftOutlined /> Atrás</b>
                            </p>
                            : null}
                    </div>
                    {
                        !selectedReview ?
                            <> 
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                                    <PageFilters>
                                        <PageFilterField label='Estado' active={filterStatus !== ''}>
                                            <Segmented
                                                value={filterStatus}
                                                options={[
                                                    { label: 'Todas', value: '' },
                                                    { label: 'Pendientes', value: '&status=NOT_REPLIED'},
                                                    { label: 'Respondidas', value: '&status=REPLIED' }
                                                ]}
                                                onChange={(value: any) => { setFilterStatus(value); setRequestParams(value + filterScore + filterReference) }}
                                            />
                                        </PageFilterField>
                                        <PageFilterField label='Puntuación' active={filterScore !== ''}>
                                            <Segmented
                                                value={filterScore}
                                                options={[
                                                    { label: 'Todas', value: '' },
                                                    {
                                                        label: (
                                                            <Tooltip title='Positivas'>
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: '#389e0d' }}>
                                                                    <StarFilled /><StarFilled /><StarFilled /><StarFilled />
                                                                </span>
                                                            </Tooltip>
                                                        ),
                                                        value: '&score=POSITIVES',
                                                    },
                                                    {
                                                        label: (
                                                            <Tooltip title='Negativas'>
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: 'crimson' }}>
                                                                    <StarFilled /><StarFilled />
                                                                </span>
                                                            </Tooltip>
                                                        ),
                                                        value: '&score=NEGATIVES',
                                                    },
                                                ]}
                                                onChange={(value: any) => { setFilterScore(value); setRequestParams(filterStatus + value + filterReference) }}
                                            />
                                        </PageFilterField>
                                        <PageFilterField label='Periodo'>
                                            <SelectPeriod setSelectedType={onRangeChange} defaultValue={reviewsDrawer.range}/>
                                        </PageFilterField>
                                    </PageFilters>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', borderRadius:'15px'}}>
                                    {reviewsList && 
                                        <ResultsPagination
                                            pagination={pagination}
                                            pageItemsCount={reviewsList.length}
                                            align='end'
                                            onPrev={() => {
                                                setRequestParams('page=' + (pagination.page - 1) + filterStatus + filterScore + filterReference);
                                            }}
                                            onNext={() => {
                                                setRequestParams('page=' + (pagination.page + 1) + filterStatus + filterScore + filterReference);
                                            }}
                                        />
                                    }
                                </div>
                                {!isLoading ?
                                    reviewsList && <Reviews reviewsData={reviewsList} handleReviewClick={handleReviewClick} width='100%' />
                                    :
                                    <div style={{height: '50%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                        <Spin/>
                                    </div>
                                }
                            </>
                            :                            
                            <CardDetailsReview reviewId={selectedReview?.name} drawer={true} onFinish={() => {nextReview(selectedReview);}} categories={categories}/>
                    }
                </Drawer>
            )}
        </>
    );
};
